import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../../core/services/translate-service';

@Pipe({
    name: 'arabicNumbers',
    pure: false, // Set the pipe to be impure
})
export class ArabicNumbersPipe implements PipeTransform {
    private arabicNumbers: { [key: string]: string } = {
        '0': '٠',
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
    };

    constructor(private translationService: TranslationService) { }

    transform(value: number | string): string {
        const currentLang = this.translationService.getCurrentLanguage();
        if (currentLang === 'ar') {
            return value
                .toString()
                .replace(/\d/g, (digit: string) => this.arabicNumbers[digit] || digit);
        }
        return value.toString(); // Return the original value in non-Arabic languages
    }
}